module.exports = __webpack_public_path__ + "img/logo_app_glow.8fe71b0c.png";